import { render, staticRenderFns } from "./CardRegistrosExcel.vue?vue&type=template&id=32f943c7&scoped=true"
import script from "./CardRegistrosExcel.vue?vue&type=script&lang=js"
export * from "./CardRegistrosExcel.vue?vue&type=script&lang=js"
import style0 from "./CardRegistrosExcel.vue?vue&type=style&index=0&id=32f943c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f943c7",
  null
  
)

export default component.exports